const RANKS = {
  hospital_admin: 'l1',
  induction_admin: 'induction-admin',
  user: 'user',
};

const events = {
  WEB_LOGGED_IN: 'web-logged-in',
  WEB_SIGNED_UP: 'web-signed-up',
  WEB_DASHBOARD_VIEWED: 'web-dashboard-viewed',
  WEB_APPROVED_USERS_VIEWED: 'web-approved-users-viewed',
  WEB_ACCEPTED_INVITES_VIEWED: 'web-accepted-invites-viewed',
  WEB_ACCESS_REQUESTS_VIEWED: 'web-access-requests-viewed',
  WEB_ACCESS_REQUEST_PROCESSED: 'web-access-request-processed',
  WEB_ACCESS_REQUEST_DELETED: 'web-access-request-deleted',
  WEB_PENDING_INVITES_VIEWED: 'web-pending-invites-viewed',
  WEB_PENDING_INVITE_CREATED: 'web-pending-invite-created',
  WEB_PENDING_INVITE_DELETED: 'web-pending-invite-deleted',
  WEB_DOCUMENT_REVIEWS_VIEWED: 'web-document-reviews-viewed',
  WEB_DOCUMENT_REVIEW_PROCESSED: 'web-document-review-processed',
  WEB_DOCUMENT_ADDED: 'web-document-added',
  WEB_DOCUMENT_EDITED: 'web-document-edited',
  WEB_FOLDER_ADDED: 'web-folder-added',
  WEB_SUBFOLDER_ADDED: 'web-subfolder-added',
  CONFIRM_ORGANISATION: 'web-confirm-organisation-prompt',
  WEB_ORGANISATION_CREATED: 'web-org-created',
  WEB_ORGANISATION_MESSAGING_ENABLED: 'web-org-messaging-enabled',
  WEB_ORGANISATION_MESSAGING_DISABLED: 'web-org-messaging-disabled',
  WEB_ORGANISATION_NHS_AUTH_ENABLED: 'web-org-NHS-auth-enabled',
  WEB_ORGANISATION_NHS_AUTH_DISABLED: 'web-org-NHS-auth-disabled',
  WEB_ORGANISATION_NHS_AUTH_EXPIRATION_UPDATED:
    'web-org-NHS-auth-expiration-updated',
  WEB_ORGANISATION_CRITICAL_ALERTS_ENABLED: 'web-org-critical-alerts-enabled',
  WEB_ORGANISATION_CRITICAL_ALERTS_DISABLED: 'web-org-critical-alerts-disabled',
  WEB_ORGANISATION_DIRECTORY_MONITORING_ENABLED:
    'web-org-directory-monitoring-enabled',
  WEB_ORGANISATION_DIRECTORY_MONITORING_DISABLED:
    'web-org-directory-monitoring-disabled',
  WEB_ORGANISATION_LOCK_NUMBERS_ENABLED: 'web-org-lock-numbers-enabled',
  WEB_ORGANISATION_LOCK_NUMBERS_DISABLED: 'web-org-lock-numbers-disabled',
  WEB_DIRECTORY_IMPORTED: 'web-directory-imported',
  WEB_DIRECTORY_IMPORT_FAILED: 'web-directory-import-failed',
  WEB_DIRECTORY_EXPORTED: 'web-directory-exported',
  WEB_ORGANISATION_MESSAGE_STORAGE_UPDATED: 'web-org-message-storage-updated',
  WEB_DIRECTORY_ENABLED: 'web-directory-enabled',
  WEB_DIRECTORY_DISABLED: 'web-directory-disabled',
  WEB_LOGGED_OUT_USER_DEVICE: "web-logged-out-user's-device",
  WEB_LOGGED_OUT_OWN_DEVICE: 'web-logged-out-own-device',
  WEB_NUMBER_LOCKED: 'web-number-locked',
  WEB_NUMBER_UNLOCKED: 'web-number-unlocked',
};

const eventNameWithRank = (name, rank) =>
  name.replace(/web-/gi, `web-${RANKS[rank]}-`);

const identify = id => {};

const track = (name, hospital, customProps = {}) => {};

const trackWithRank = (name, hospital, rank, customProps = {}) => {
  track(eventNameWithRank(name, rank), hospital, customProps);
};

export const Mixpanel = {
  identify,
  track,
  trackWithRank,
  events,
};
